export default {
	data() {
		return {
			isTransitioning: false,
		};
	},
	computed: {
		// ...mapState({
		// 	view: state => state.views.component,
		// }),
		view() {
			return this.$router.currentRoute.name;
		},
		transitionName() {
			let transitionName = "";

			switch (this.view) {
			default:
				transitionName = "fade";
				break;
			}

			return transitionName;
		},
		transitionMode() {
			let transitionMode = "";

			switch (this.view) {
			default:
				transitionMode = "";
				break;
			}

			return transitionMode;
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/transition-settings.js